




























































































































































import {Component, Ref, Vue, Watch} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import {cloneDeep, isEqual} from "lodash";
import {InputWings, SelectWings, TextareaWings} from "wings-ui-components";
import {notifyConfirm, notifyDelete, notifyError} from "@/utils/notify-helper";
import {PushApplicationItem, PushApplicationItemImpl} from "@/store/push/application/types";
import {md5} from 'pure-md5';
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";
import WebPushSettings from "@/components/Push/Applications/WebPushSettings.vue";
import FcmSettings from "@/components/Push/Applications/FcmSettings.vue";
import ApnsSettings from "@/components/Push/Applications/ApnsSettings.vue";
import HmsSettings from "@/components/Push/Applications/HmsSettings.vue";
import XiaomiSettings from "@/components/Push/Applications/XiaomiSettings.vue";
import DpSettings from "@/components/Push/Applications/DpSettings.vue";
import Dp2Settings from "@/components/Push/Applications/Dp2Settings.vue";
import RuStoreSettings from "@/components/Push/Applications/RuStoreSettings.vue";
import PartnerSelectionCard from "@/components/Others/PartnerSelectionCard.vue";
import {MsgTransports} from "@/store/types";

Component.registerHooks([
  'beforeRouteLeave',
]);

@Component({components: {
    WebPushSettings,
    PartnerSelectionCard,
    Dp2Settings,
    DpSettings,
    XiaomiSettings,
    HmsSettings,
    ApnsSettings,
    FcmSettings,
    SelectWings,
    InputWings,
    RuStoreSettings,
    TextareaWings
}})
export default class PushApplication extends Vue {
  @Action("getPushApplicationItem") actionGetItem: any;
  @Action("savePushApplication") actionSave: any;
  @Action("deletePushApplication") actionDelete: any;
  @Action("uploadCertFile") actionUploadCertFile: any;
  @Action("actionLog") actionLog: any;
  @Action("getProxySettings") actionGetProxySettings: any;

  @Getter("devicesList") devicesList: any;
  @Getter("xiaomiRegionList") regionList: any;

  @Ref('validator') validator: any;

  private item: PushApplicationItem = this.defaultItem();
  private itemSaved: PushApplicationItem = this.defaultItem();
  private logObject: ActionLog = {};
  files: { file: File; type: string;  }[] = [];
  partners: any = [];
  transport: MsgTransports = MsgTransports.PUSH;

  defaultItem(): PushApplicationItem {
    return new PushApplicationItemImpl()
  }

  getSlotname(index:number) {
    return `tab-pane-${++index}`
  }

  async created() {
    this.actionGetProxySettings();
    if (this.$route.params.id) {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Push application",
        object_name: this.item.name,
        addititional_info: getTranslatedParams(this.item)
      }
      try {
        const data: PushApplicationItem = await this.actionGetItem(this.$route.params.id);
        this.item = Object.assign({}, this.item, data);
        this.item.partners.forEach((e:any)=>{
          if (e.allowed){
            this.item.partner_ids.push(e.id);
            this.partners.push({id: e.id, name: e.partner_name});
          }
        });
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
        this.actionLog(this.logObject);
      } catch (err){
        this.actionLog({...this.logObject, action_status: "failed"});
      }
    }
  }

  async onSaveItem(): Promise<void> {
    if (!await this.validator.validate()) {
      notifyError(null, this.validator.errors)
      return;
    }
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: this.$route.params.id ? "Editing" : "Creation",
        action_status: "success",
        object_type: "Push application",
        object_name: this.item.name,
        addititional_info: getTranslatedParams(this.item)
      }
      for (const file of this.files) {
        await this.uploadCert(file.file, file.type)
      }
      if (this.item.apns.certificate_type === 'p8') {
        this.item.apns.certificate_path = null
        this.item.apns.passphrase = null
      } else {
        this.item.apns.key_path = null
        this.item.apns.key_id = null
        this.item.apns.team_id = null
      }
      if (this.item.fcm.protocol === 'HTTPv1') {
        this.item.fcm.fcm_key = null
        this.item.fcm.sender_id = null
      } else {
        this.item.fcm.service_account_path = null
      }
      await this.actionSave(this.cleanedItems());
      await this.actionLog(this.logObject);
      this.itemSaved = cloneDeep(this.item);
      this.back();
    } catch (error) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(error);
    }
  }

  async onDeleteItem(): Promise<void> {
    let isConfirm: boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "Push application",
          object_name: this.item.name,
          addititional_info: getTranslatedParams({id: this.item.id})
        }
        await this.actionDelete(this.item);
        await this.actionLog(this.logObject);
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  get isWebPush(): boolean {
    return this.item.web.public_key !== null
  }

  set isWebPush(value: boolean) {
    if (value) {
      this.item.web.public_key = ''
    } else {
      this.item.web.public_key = null
      this.item.web.private_key = null
      this.item.web.sender_signature = null
    }
  }

  get isFCM(): boolean {
    return this.item.fcm.server_type !== null
  }

  set isFCM(value: boolean) {
    if (value) {
      this.item.fcm.server_type = ''
      this.item.fcm.connection_count = this.item.fcm.protocol === 'XMPP' ? 5 : 15;
    } else {
      this.item.fcm.server_type = null
      this.item.fcm.fcm_key = null
      this.item.fcm.sender_id = null
      this.item.fcm.connection_count = null
      this.item.fcm.service_account_path = null
      this.item.fcm.ip = null
      this.item.fcm.port = null
    }
  }

  get isAPNS(): boolean {
    return this.item.apns.certificate_type !== null
  }

  set isAPNS(value: boolean) {
    if (value) {
      this.item.apns.certificate_type = 'p8'
    } else {
      this.item.apns.server_type = null
      this.item.apns.topic = null
      this.item.apns.certificate_type = null
      this.item.apns.team_id = null
      this.item.apns.key_id = null
      this.item.apns.passphrase = null
      this.item.apns.certificate_path = null
      this.item.apns.ip = null
      this.item.apns.port = null
    }
  }

  get isHMS(): boolean {
    return this.item.hms.client_id !== null && this.item.hms.client_secret !== null
  }

  set isHMS(value: boolean) {
    if (value) {
      this.item.hms.client_id = ''
      this.item.hms.client_secret = ''
    } else {
      this.item.hms.server_type = null
      this.item.hms.client_id = null
      this.item.hms.client_secret = null
      this.item.hms.ip = null
      this.item.hms.port = null
    }
  }

  get isXiaomi(): boolean {
    return this.item.xiaomi.app_id !== null
  }

  set isXiaomi(value: boolean) {
    if (value) {
      this.item.xiaomi.app_id = ''
    } else {
      this.item.xiaomi.server_type = null
      this.item.xiaomi.app_id = null
      this.item.xiaomi.ip = null
      this.item.xiaomi.port = null
    }
  }

  get isDP(): boolean {
    return this.item.dp.server_ip !== null;
  }

  set isDP(value: boolean) {
    if (value) {
      this.item.dp.server_ip = '';
    } else {
      this.item.dp.server_ip = null;
    }
  }

  get isDP2(): boolean {
    return this.item.dp2.address !== null;
  }

  set isDP2(value: boolean) {
    if (value) {
      this.item.dp2.address = '';
    } else {
      this.item.dp2.address = null;
    }
  }

  get isRuStore(): boolean {
    return this.item.rustore.project_id !== null;
  }

  set isRuStore(value: boolean) {
    if (value) {
      this.item.rustore.project_id = '';
      this.item.rustore.service_token = '';
    } else {
      this.item.rustore.server_type = null
      this.item.rustore.project_id = null;
      this.item.rustore.service_token = null;
      this.item.rustore.ip = null
      this.item.rustore.port = null
    }
  }

  back(): void {
    this.$router.push(`/push/applications`);
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  private async uploadCert(file?: File, type?: string | null) {
    const readPromise = new Promise<any>((resolve, reject) => {
      let fr = new FileReader();
      fr.onerror = reject;
      fr.onload = () => resolve(new Uint8Array(<ArrayBuffer>fr.result));
      if (file) {
        fr.readAsArrayBuffer(file);
      } else {
        reject('No file')
      }
    });
    const byteArray: number[] = await readPromise;
    const fileString: string = String.fromCharCode(...byteArray);
    const request = {
      name: this.getCertificatePath(type),
      base64: btoa(fileString),
      md5: md5(fileString)
    }
    return await this.actionUploadCertFile(request);
  }

  private getCertificatePath(certificateType?: string | null) {
    switch (certificateType) {
      case 'p8':
        return this.item.apns.key_path;
      case 'p12':
        return this.item.apns.certificate_path;
      case 'HTTPv1':
        return this.item.fcm.service_account_path;
      case 'jks':
        return this.item.dp.truststore_path;
    }
  }

  // TODO надо заменить все заполнение null на undefined и убрать этот метод
  cleanedItems() {
    let value: PushApplicationItem = cloneDeep(this.item);
    if (!this.isWebPush) delete value.web;
    if (!this.isFCM) delete value.fcm;
    if (!this.isAPNS) delete value.apns;
    if (!this.isHMS) delete value.hms;
    if (!this.isXiaomi) delete value.xiaomi;
    if (!this.isDP) delete value.dp;
    if (!this.isDP2) delete value.dp2;
    if (!this.isRuStore) delete value.rustore;

    return value;
  }

  @Watch('item.apns.certificate_type', {deep: true, immediate:false})
  onChangeCertificateType(old_val: object, new_val: object) {
    if (old_val != new_val && new_val !== null) {
      this.item.apns.team_id = this.itemSaved.apns.team_id;
      this.item.apns.key_id = this.itemSaved.apns.key_id;
      this.item.apns.passphrase = this.itemSaved.apns.passphrase;
      this.item.apns.certificate_path = this.itemSaved.apns.certificate_path;
      this.item.apns.key_path = this.itemSaved.apns.key_path;
    }
  }

  @Watch('item.fcm.protocol', {deep: true, immediate: false})
  onFcmProtocol(new_val: string, old_val: string) {
    if (new_val !== old_val && new_val !== null) {
      if (!this.itemSaved.fcm.connection_count) this.item.fcm.connection_count = new_val === 'XMPP' ? 5 : 15;
      else {
        if (this.itemSaved.fcm.protocol === 'XMPP'){
          this.item.fcm.connection_count = new_val === 'XMPP' ? this.itemSaved.fcm.connection_count : 15;
        } else {
          this.item.fcm.connection_count = new_val === 'XMPP' ? 5 : this.itemSaved.fcm.connection_count;
        }
      }
    }
  }
}
